// The id of the <template> that carries the prefetch hints from the server, which moves
// them out of the head (server/plugins/deferredPrefetch.ts), to the client, which puts
// them back after hydration (app/plugins/deferred-prefetch.client.ts).
export const DEFERRED_PREFETCH_ID = 'deferred-prefetch'
